var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("form-button-disabler", [
    _c(
      "div",
      { staticClass: "grid grid-cols-2 gap-x-4 gap-y-2 pb-4" },
      [
        _vm.selectedFields.length === 0
          ? _c(
              "div",
              {
                staticClass:
                  "col-span-2 flex flex-col rounded border-gray-400 border justify-center items-center py-10",
              },
              [_vm._v("\n      No Fields Added. Please Add Below.\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.selectedFields, function (item, i) {
          return [
            _c(
              "div",
              {
                key: `${item.field?.internalFieldId ?? `new-${i}`}-field`,
                staticClass: "flex items-center",
              },
              [
                _c("i", {
                  staticClass: "mdi mdi-close mdi-18px cursor-pointer mr-2",
                  on: {
                    click: function ($event) {
                      return _vm.removeField(item)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "field",
                  { staticClass: "flex-grow" },
                  [
                    _c("dropdown-field", {
                      attrs: {
                        value: item.field,
                        placeholder: "Select Field...",
                        source: _vm.fieldSource,
                        "text-field": "displayName",
                        searchable: "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.setField(item, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "field",
              {
                key: `${item.field?.internalFieldId ?? `new-${i}`}-value`,
                attrs: { disabled: item.field === null },
              },
              [
                item.inputType === "number"
                  ? _c("number-field", {
                      model: {
                        value: item.value,
                        callback: function ($$v) {
                          _vm.$set(item, "value", $$v)
                        },
                        expression: "item.value",
                      },
                    })
                  : item.inputType === "date"
                  ? _c("date-field", {
                      model: {
                        value: item.value,
                        callback: function ($$v) {
                          _vm.$set(item, "value", $$v)
                        },
                        expression: "item.value",
                      },
                    })
                  : item.inputType === "enum"
                  ? _c("dropdown-field", {
                      attrs: {
                        source: item.source,
                        placeholder: "Select Enum Value...",
                        "text-field": "displayName",
                        "value-field": "name",
                        searchable: "",
                        clearable: "",
                      },
                      model: {
                        value: item.value,
                        callback: function ($$v) {
                          _vm.$set(item, "value", $$v)
                        },
                        expression: "item.value",
                      },
                    })
                  : _c("text-field", {
                      model: {
                        value: item.value,
                        callback: function ($$v) {
                          _vm.$set(item, "value", $$v)
                        },
                        expression: "item.value",
                      },
                    }),
              ],
              1
            ),
          ]
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-span-2 flex" },
          [
            _c(
              "action",
              {
                attrs: { icon: "mdi mdi-plus" },
                on: {
                  click: function ($event) {
                    return _vm.addEmptyField()
                  },
                },
              },
              [_vm._v("Add New Field")]
            ),
          ],
          1
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pb-4" },
      [
        _c("checkbox", {
          attrs: { label: "Allow mapped NULLs to overwrite previous values" },
          model: {
            value: _vm.keepNull,
            callback: function ($$v) {
              _vm.keepNull = $$v
            },
            expression: "keepNull",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex" },
      [
        _c(
          "action",
          {
            staticClass: "ml-2",
            attrs: { icon: "mdi mdi-download" },
            on: {
              click: function ($event) {
                return _vm.downloadTemplate()
              },
            },
          },
          [_vm._v("Download Template")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex-grow" }),
        _vm._v(" "),
        _c(
          "btn",
          {
            attrs: { disabled: _vm.saving },
            on: {
              click: function ($event) {
                return _vm.updateInternalData()
              },
            },
          },
          [_vm._v("Update")]
        ),
        _vm._v(" "),
        _c(
          "btn",
          {
            attrs: { outlined: "" },
            on: {
              click: function ($event) {
                return _vm.closeProp()
              },
            },
          },
          [_vm._v("Cancel")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }